import React from 'react';
export default function BeehiveHatSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Beehive body - stacked rings */}
      <ellipse cx="20" cy="34" rx="14" ry="4" fill="#BF8C2E" />
      <ellipse cx="20" cy="28" rx="12" ry="4" fill="#D4A03A" />
      <ellipse cx="20" cy="22" rx="10" ry="4" fill="#E8B44C" />
      <ellipse cx="20" cy="16" rx="8" ry="4" fill="#F0C464" />
      <ellipse cx="20" cy="11" rx="5" ry="3" fill="#F5D080" />

      {/* Ring grooves */}
      <path d="M8 34 C8 32 14 30 20 30 C26 30 32 32 32 34" stroke="#A67824" strokeWidth="0.8" fill="none" />
      <path d="M10 28 C10 26 14 24 20 24 C26 24 30 26 30 28" stroke="#B88C30" strokeWidth="0.8" fill="none" />
      <path d="M12 22 C12 20 16 18 20 18 C24 18 28 20 28 22" stroke="#C89E3C" strokeWidth="0.8" fill="none" />

      {/* Entrance hole */}
      <ellipse cx="20" cy="32" rx="3" ry="2" fill="#6D4C1A" />

      {/* Honey drip on left */}
      <path d="M10 34 L10 37 C10 39 12 39 12 37 L12 34" fill="#FFB300" />
      {/* Honey drip on right */}
      <path d="M28 34 L28 36 C28 38 30 38 30 36 L30 34" fill="#FFB300" />

      {/* Small bee */}
      <ellipse cx="32" cy="12" rx="3" ry="2" fill="#FFD54F" />
      <rect x="30.5" y="11" width="1" height="2" fill="#3E2723" />
      <rect x="32.5" y="11" width="1" height="2" fill="#3E2723" />
      {/* Bee wings */}
      <ellipse cx="31" cy="10" rx="2" ry="1.2" fill="white" opacity="0.6" />
      <ellipse cx="33" cy="10" rx="2" ry="1.2" fill="white" opacity="0.6" />
      {/* Bee eyes */}
      <circle cx="34" cy="11.5" r="0.5" fill="#3E2723" />

      {/* Bee flight path (dotted) */}
      <path d="M30 14 C28 16 26 14 28 12" stroke="#FFD54F" strokeWidth="0.4" strokeDasharray="1 1" fill="none" opacity="0.4" />
    </svg>
  );
}
